import { Input } from 'twyne-new.ui';

export default function AuthInput({ children, ...rest }) {
  return <Input {...rest}>
    {children}
  </Input>
}
